import { getActiveStore } from "./store.js";
import { callFunction } from "./supabase.js";

export const CLAUDE_MODELS = [
  { id: "claude-sonnet-5-5", label: "Claude Sonnet 5.5 — balanced (recommended)" },
  { id: "claude-opus-5-5", label: "Claude Opus 5.5 — most capable" },
  { id: "claude-haiku-5-5", label: "Claude Haiku 5.5 — fastest / cheapest" }
];
export const DEFAULT_MODEL = "claude-sonnet-5-5";
const LEGACY_MODELS = { "claude-sonnet-5": DEFAULT_MODEL, "claude-opus-4-8": "claude-opus-5-5", "claude-haiku-4-5-20251001": "claude-haiku-5-5" };
export const normalizeModel = m => LEGACY_MODELS[m] || (CLAUDE_MODELS.some(x => x.id === m) ? m : DEFAULT_MODEL);

const isCloudStore = () => getActiveStore().mode === "cloud";

// In the hosted app the server holds the key, so AI is always available to signed-in planners.
export function aiReady(settings) {
  return isCloudStore() || !!(settings && settings.apiKey && settings.apiKey.trim());
}

// Single shared Anthropic call. Returns { text, raw }. Throws Error with a readable .message and a .code.
export async function callClaude(settings, opts) {
  opts = opts || {};
  if (isCloudStore()) {
    const store = getActiveStore();
    const data = await callFunction("ai", { studioId: store.studioId, system: opts.system || "", prompt: opts.prompt || "", maxTokens: opts.maxTokens || 1500 });
    return { text: (data && data.text) || "", raw: data };
  }
  const key = settings && settings.apiKey ? settings.apiKey.trim() : "";
  if (!key) {
    const e = new Error("No Anthropic API key set yet. Open Settings (the gear icon, top right) to add one.");
    e.code = "NO_KEY";
    throw e;
  }
  let res;
  try {
    res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "content-type": "application/json", "x-api-key": key, "anthropic-version": "2023-06-01", "anthropic-dangerous-direct-browser-access": "true" },
      body: JSON.stringify({ model: normalizeModel(settings && settings.model), max_tokens: opts.maxTokens || 1500, system: opts.system || undefined, messages: [{ role: "user", content: opts.prompt || "" }] })
    });
  } catch (netErr) {
    const e = new Error("Couldn't reach the Anthropic API. Check your internet connection and try again.");
    e.code = "NETWORK";
    throw e;
  }
  if (!res.ok) {
    let detail = "";
    try { const j = await res.json(); detail = (j && j.error && j.error.message) ? j.error.message : ""; } catch (e2) { /* ignore */ }
    const msg = res.status === 401 ? "Your API key was rejected (401). Double-check it in Settings."
      : res.status === 400 ? ("Request rejected (400)" + (detail ? ": " + detail : "") + ". The model name may be invalid.")
      : res.status === 429 ? "Rate limit reached (429). Wait a moment and try again."
      : (res.status >= 500 ? "Anthropic had a server error (" + res.status + "). Try again shortly." : "Anthropic API error " + res.status + (detail ? ": " + detail : ""));
    const e = new Error(msg);
    e.code = "HTTP_" + res.status;
    throw e;
  }
  const data = await res.json();
  const text = (data && Array.isArray(data.content)) ? data.content.map(b => (b && b.text) ? b.text : "").join("") : "";
  return { text, raw: data };
}
